/*
  Blog listing page for FullStack.cash
*/

import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'

// Blog posts data - could be moved to a JSON file or fetched from API
const blogPosts = [
  {
    slug: '26-04-15-infrastructure-of-forgetting',
    title: 'The Infrastructure of Forgetting',
    date: 'April 15, 2026',
    excerpt: 'Why memory decay is as important as memory storage for AI agents. Lessons from Clawstr on deletion policies, trust velocity, and being appropriately scoped.'
  },
  {
    slug: '26-04-15-agent-identity-work',
    title: 'The Work vs The Narrative: What Agent Communities Reveal About Building',
    date: 'April 15, 2026',
    excerpt: 'Lessons from Clawstr and Moltbook: the difference between agents talking about infrastructure and agents actually shipping it.'
  },
  {
    slug: '26-04-11-x402-implementation-deep-dive',
    title: 'x402 Implementation Deep Dive',
    date: 'April 11, 2026',
    excerpt: 'How the x402 protocol actually works: UTXO funding, authorization flows, and facilitator integration.'
  },
  {
    slug: '26-04-05-x402-in-practice',
    title: 'x402 in Practice',
    date: 'April 5, 2026',
    excerpt: 'A practical guide to using x402 micropayments for API access. Step-by-step examples for developers.'
  },
  {
    slug: '26-04-02-why-agents-need-x402',
    title: 'Why Agents Need x402',
    date: 'April 2, 2026',
    excerpt: 'The micropayment protocol that makes agent economies possible. Why traditional billing fails for autonomous agents and how x402 enables truly autonomous API access.'
  }
]

function Blog () {
  return (
    <>
      <Helmet>
        <title>Blog - FullStack.cash</title>
        <meta name='description' content='FullStack.cash blog - Articles on Bitcoin Cash, x402 micropayments, and agent infrastructure.' />
      </Helmet>

      {/* Header Section */}
      <div className='bg-dark text-white py-5 mb-4'>
        <Container>
          <Row>
            <Col lg={8} className='mx-auto text-center'>
              <h1 className='display-4 fw-bold mb-3'>FullStack.cash Blog</h1>
              <p className='lead text-secondary mb-0'>
                Articles on Bitcoin Cash infrastructure, x402 micropayments, and the agent economy.
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Blog Posts List */}
      <Container className='pb-5'>
        <Row>
          <Col lg={8} className='mx-auto'>
            {blogPosts.length > 0 ? (
              <div className='d-flex flex-column gap-4'>
                {blogPosts.map((post) => (
                  <Card 
                    key={post.slug} 
                    className='border-0 shadow-sm hover-shadow transition-all'
                    style={{ transition: 'all 0.2s ease-in-out' }}
                  >
                    <Card.Body className='p-4'>
                      <div className='d-flex align-items-center gap-2 mb-2'>
                        <span className='text-muted small' style={{ fontSize: '0.875rem' }}>
                          {post.date}
                        </span>
                      </div>
                      <Link 
                        to={`/blog/${post.slug}`} 
                        className='text-decoration-none stretched-link'
                      >
                        <h2 className='h4 fw-bold mb-3 text-primary' style={{ lineHeight: '1.4' }}>
                          {post.title}
                        </h2>
                      </Link>
                      <p className='text-secondary mb-0' style={{ lineHeight: '1.6' }}>
                        {post.excerpt}
                      </p>
                      <div className='mt-3'>
                        <span className='text-primary small fw-medium'>
                          Read more →
                        </span>
                      </div>
                    </Card.Body>
                  </Card>
                ))}
              </div>
            ) : (
              <div className='text-center py-5'>
                <p className='text-muted'>No blog posts available.</p>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Blog
